module.exports = __webpack_public_path__ + "img/electronic_use_selected.bbf22fa9.svg";